import { parseContractReference } from './contractReference';

export type ObjectReturnScanResult =
    | { ok: true; contractNr: number }
    | { ok: false; reason: 'invalid' | 'not-pending' };

/** Resolve a label/number only when its contract is waiting in the handover queue. */
export function resolveObjectReturnScan(
    raw: string,
    pendingContractNrs: readonly number[],
): ObjectReturnScanResult {
    const parsed = parseContractReference(raw, { allowBareNumber: true });
    if (!parsed.ok) {
        return { ok: false, reason: 'invalid' };
    }
    if (!pendingContractNrs.includes(parsed.value.contractNumber)) {
        return { ok: false, reason: 'not-pending' };
    }
    return { ok: true, contractNr: parsed.value.contractNumber };
}
